const app = {
  state: {
    errorRequest: null,
    messageResponse: null,
  },
  getters: {
    errorRequest: state => state.errorRequest,
    messageResponse: state => state.messageResponse,
  },
  mutations: {
    SET_ERROR_REQUEST: (state, data) => {
      state.errorRequest = data;
    },
    SET_MESSAGE_RESPONSE: (state, data) => {
      state.messageResponse = data;
    },
  },
  actions: {
    updateErrorRequest({ commit }, payload) {
      commit('SET_ERROR_REQUEST', payload);
    },
    updateMessageResponse({ commit }, payload) {
      commit('SET_MESSAGE_RESPONSE', payload);
    },
  },
};

export default app;
